// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__JKGBJ","imgArea":"menu_imgArea__vsbwb","selected":"menu_selected__cX+T7","infoArea":"menu_infoArea__PWTy4"};